import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {TopStatsClickEvent} from "../models/events/top-stats-click-event";

export class TopStatsClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.topStatsClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = TopStatsClickEvent;
  }
}
